import NepaliDate from "nepali-date-converter";

export const formatDateTime = (isoString: string) => {
  const date = new Date(isoString);

  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export const getRemainingTime = (endDateStr: string, gracePeriodDays: number): string => {
  if (!endDateStr) return "No end date";

  const now = new Date();
  const endDate = new Date(endDateStr);
  const diffMs = endDate.getTime() - now.getTime();

  if (diffMs > 0) {
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    // More than a month
    // if (days >= 30) {
    //   const months = Math.floor(days / 30);
    //   const remainingDays = days % 30;
    //   if (remainingDays > 0) {
    //     return `${months} month${months !== 1 ? 's' : ''} ${remainingDays} day${remainingDays !== 1 ? 's' : ''} remaining`;
    //   }
    //   return `${months} month${months !== 1 ? 's' : ''} remaining`;
    // }

    // More than a day
    if (days > 0) {
      if (hours > 0) {
        return `${days} day${days !== 1 ? "s" : ""} ${hours} hour${hours !== 1 ? "s" : ""} remaining`;
      }
      if (minutes > 0) {
        return `${days} day${days !== 1 ? "s" : ""} ${minutes} minute${minutes !== 1 ? "s" : ""} remaining`;
      }
      return `${days} day${days !== 1 ? "s" : ""} remaining`;
    }

    // More than an hour
    if (hours > 0) {
      if (minutes > 0) {
        return `${hours} hour${hours !== 1 ? "s" : ""} ${minutes} minute${minutes !== 1 ? "s" : ""} remaining`;
      }
      return `${hours} hour${hours !== 1 ? "s" : ""} remaining`;
    }

    // More than a minute
    if (minutes > 0) {
      return `${minutes} minute${minutes !== 1 ? "s" : ""} remaining`;
    }

    return "Less than a minute remaining";
  }

  // Plan expired, check if within grace period
  const graceEndDate = new Date(endDate);
  graceEndDate.setDate(graceEndDate.getDate() + (gracePeriodDays ? gracePeriodDays : 0));

  if (now <= graceEndDate) {
    const diffMsGrace = graceEndDate.getTime() - now.getTime();
    const graceDaysLeft = Math.ceil(diffMsGrace / (1000 * 60 * 60 * 24));
    return `In grace period (${graceDaysLeft} day${graceDaysLeft > 1 ? "s" : ""} left)`;
  }

  return "Expired";
};

/**
 * Convert AD date (YYYY-MM-DD | Date) to BS date (YYYY-MM-DD)
 */
export function AdToBs(adDate: string | Date): string {
  try {
    const date = typeof adDate === "string" ? new Date(adDate) : adDate;
    if (isNaN(date.getTime())) return "";
    const nepDate = new NepaliDate(date);
    return `${nepDate.getYear()}-${String(nepDate.getMonth() + 1).padStart(2, "0")}-${String(nepDate.getDate()).padStart(2, "0")}`;
  } catch (error) {
    console.error("Error converting AD to BS:", error);
    return "--";
  }
}
